import { BaseFormComponent, BaseFormHeaderInfo } from '../../tasks/baseFormComponent/baseForm.component';
import { Component, OnInit, Optional, ElementRef, AfterContentInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { FormConfig } from '../../components/forms/form.objects';
import { generateRandomIdentifier } from '../../ui.service';
import { PersonDTO } from '../../api/plyca-dtos';
import { PropertyService } from '../../properties/property.service';
import { PlycaErrorHandler } from '../../../http/PlycaErrorHandler';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng-lts/dynamicdialog';
import { tap, finalize } from 'rxjs/operators';

export class PersonModel {

  dto: PersonDTO;
  ui: any;
}

@Component({
  selector: 'person-form',
  templateUrl: '../../tasks/baseFormComponent/baseForm.template.html'
})
export class PersonEditionComponent
  extends BaseFormComponent<PersonDTO, PersonModel>
  implements OnInit, AfterContentInit, OnDestroy {


  private identifier: string;
  readonly = false;
  operation: string;
  private properties = {};

  constructor(
    elem: ElementRef,
    public translationService: TranslateService,
    public dialogConfig: DynamicDialogConfig,
    public ref: DynamicDialogRef,
    private propertyService: PropertyService,
    private plycaErrorHandler: PlycaErrorHandler,
    @Optional() protected activatedRoute: ActivatedRoute

  ) {
    super(elem);
    this.identifier = dialogConfig['id'];
    this.operation = dialogConfig['operation'];
    this.readonly = this.operation && this.operation == 'show';
    this.windowHash = generateRandomIdentifier();

  }

  ngOnDestroy(): void {
    this.dialogConfig = null;
    this.ref = null;
    super.ngOnDestroy();
  }



  ngAfterContentInit(): void {



  }

  getFormSettingURL(): string {
    return 'admin/personISettings.json';
  }

  getServiceURL(operation?: string): string {

    if (operation === 'copy' || operation === 'insert' || operation === 'update') {
      return this.configuration.PERSON_ADMIN_SERVICE_URL;
    } else {
      return this.configuration.PERSON_SERVICE_URL;
    }

  }
  getObjectParams(): { [param: string]: string | string[]; } {
    return {

      'expand': 'expansionSet:manage'
    };
  }

  getObjectIdentifier(): string {
    return this.identifier;
  }


  dtoToModel(dto: PersonDTO): Observable<any> {
    let model = new PersonModel();
    // inicializacion de los campos del modelo utilizados por el json

    model.dto = dto;
    if (this.operation == 'copy') {
      model.dto.identifier = undefined;
    }


    model['ui'] = {};
    model.ui['properties'] = {};


    model.ui['operation'] = this.operation;


    return of(model)




  }



  modelToDTO(model: PersonModel): PersonDTO {
    let dto: PersonDTO;
    model.dto.identifier = model.dto.identifier.trim();
    dto = model.dto;


    dto = JSON.parse(
      JSON.stringify(dto, (k, v) => (k === '_parent' ? undefined : v))
    );
    return dto;

  }




  initHeaderActions() {

    if (!this.readonly) {


      this.subscribe(this.headerActionsService
        .addWindowAction('General.save', 'fas fa-save', 'btn-primary',
          true, this.windowHash),

        (success) => {
          if (this.operation == 'insert' || this.operation == 'copy') {
            this.subscribe(this.insert(),
              (newPerson: PersonDTO) => {
                this.waitService.cancelWaiting();
                this.uiService.showSuccess(this.translate.instant('General.msg.updateok'), this.translate.instant('General.info'),
                  'success');
                this.ref.close(newPerson);
              },
              (err) => {
                this.waitService.cancelWaiting();
                this.uiService.showSuccess('Se ha producido un error al actualizar', this.translate.instant('General.info'),
                  'error');
                // Revisar ¿error de validación? Error 404
                // this.plycaErrorHandler.showServerError(err);
              })
          } else {
            this.subscribe(this.update(),
              (newPerson: PersonDTO) => {

                this.waitService.cancelWaiting();
                this.uiService.showSuccess(this.translate.instant('General.msg.updateok'), this.translate.instant('General.info'),
                  'success');


                this.subscribe(
                  this.plycaService
                    .get(this.configuration.PERSON_SERVICE_URL, this.model.dto.identifier,
                      { expand: 'expansionSet:manage' })
                    .pipe(
                      tap(
                        (result: PersonDTO) => {
                          this.ref.close(result);
                        }),
                      finalize(() => {
                        this.waitService.cancelWaiting();
                      }
                      )
                    )
                );
              },
              (err) => {
                this.waitService.cancelWaiting();
                this.uiService.showSuccess('Se ha producido un error al actualizar', this.translate.instant('General.info'),
                  'error');
                // Revisar ¿error de validación? Error 404
                // this.plycaErrorHandler.showServerError(err);
              })
          }

        }
      );




    }
  }



  configureFormConfig(formConfig: FormConfig): Observable<FormConfig> {
    formConfig.showValidations = true;
    formConfig.isModalWindow = true;
    formConfig.windowHash = this.windowHash;
    formConfig.readonly = this.readonly;
    //    formConfig.searchTags = [HelpType.EDIT_U];

    formConfig.functions.push({
      identifier: 'setPerson',
      fn: this.setPerson
    });
    formConfig.functions.push({
      identifier: 'setUIPersons',
      fn: this.setUIPersons
    });


    return of(formConfig);
  }


  public setPerson(model: any) {
    if (model.dto.person == undefined) {
      model.ui.persons = [];
    } else {
      model.ui['persons'] = [];
      if (model.dto.person) {
        model.ui.persons.push(model.dto.person);

      }
    }


  }

  public setUIPersons(model: any) {
    if (model.ui.persons == undefined || model.ui.persons.length == 0) {
      model.dto.person = undefined;
    } else {
      model.dto.person = undefined;
      if (model.ui.persons[0]) {
        model.dto.person = model.ui.persons[0];
      }
    }


  }




  modalError(error) {
    // this.ref.close();
    this.plycaErrorHandler.showServerError(error);
    // this.uiService.showMessage(
    //   error.errors[0].message,
    //   this.translateService.instant('General.error'),
    //   'errorStyle'
    // );
  }


  public cancel() {
    this.uiService.showSuccess(
      this.translate.instant('General.msg.cancel'),
      this.translate.instant('General.info'),
      'warn'
    );
    this.ref.close();

  }
  public noImplemented() {
    this.uiService.showSuccess(
      'Operación no implementada',
      this.translate.instant('General.info'),
      'warn'
    );

  }

  getHeaderInfo(): BaseFormHeaderInfo {
    throw new Error('Method not implemented.');
  }


  getStringID(identifier: string) {
    let des = '';
    if (typeof identifier === 'string' && identifier.indexOf('<>') !== -1) {
      des = identifier.toString().substring(identifier.indexOf('>') + 1, identifier.length);
    }
    return des;
  }




  // Mantenimiento de personas
  show(model: any) {
    this.modalOpen(model, 'show');
  }

  edit(model: any) {
    let operation = model.identifier ? 'update' : 'insert';
    this.modalOpen(model, operation);
  }
  modalOpen(model: any, operation: string) {
    let config: DynamicDialogConfig = {
      header: this.translate.instant('ControlPanel.persons.actions.edit'),
      width: '90%',
      styleClass: 'formEdition'

    };

    config['id'] = model.identifier;
    config['operation'] = operation;
    // config['readonly'] = readonly

    const dialog = this.dialogService.open(PersonEditionComponent, config);
    dialog.onClose.subscribe(newInvoice => {
      //this.search();


    });

  }


}
